import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { socket } from 'api';
import { notify } from 'libs/common';
import { closeWindow } from 'store/actions/windows';
import { Window } from 'components/shared/window/window';
import { FilledButton, OutlineButton } from 'libs/ui';
import { WrapMessage, Buttons, Content } from './alert-enable.styled';

const enabled = false;

export const AlertEnable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const toggleFireAlert = () => {
    socket.call('racks.set_fire_alarm', { enable: !enabled });
    notify(t('windows.Пожарная тревога'), t('windows.Тревога включена'), 'danger');
    close();
  };

  const close = () => {
    dispatch(closeWindow('AlertConfirmModal'));
  };

  return (
    <Window header={t('windows.Пожарная тревога')} width="340px" id="AlertConfirmModal" closeWindow>
      <Content>
        <WrapMessage>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M12 3.2 1.8 20.4a1 1 0 0 0 .87 1.5h18.66a1 1 0 0 0 .87-1.5L12 3.2Z" fill="#d4a017" />
            <path d="M12 9.2v5.1" stroke="#12171c" strokeWidth="1.9" strokeLinecap="round" />
            <circle cx="12" cy="17.6" r="1.15" fill="#12171c" />
          </svg>
          <div>
            {t('windows.Все шлагбаумы будут открыты')}. {t('windows.Продолжить?')}
          </div>
        </WrapMessage>
        <Buttons>
          <FilledButton color="danger" onClick={toggleFireAlert}>
            {t('buttons.Подтвердить')}
          </FilledButton>
          <OutlineButton onClick={close}>{t('buttons.Отмена')}</OutlineButton>
        </Buttons>
      </Content>
    </Window>
  );
};
